// Utility functions for carousel images

export interface CarouselSlide {
    id: number;
    image: string;
    title: string;
    subtitle: string;
    ctaText: string;
    ctaLink: string;
}

// Get S3 base URL from environment variables
const S3_BASE_URL = process.env.REACT_APP_S3_BASE_URL || 'https://eldai-commands-images.s3.eu-north-1.amazonaws.com';
const CAROUSEL_S3_BASE_URL = `${S3_BASE_URL}/carousel/`;

export const getCarouselImageUrl = (filename: string): string => {
    return `${CAROUSEL_S3_BASE_URL}${filename}`;
};

export const getDefaultCarouselSlides = (): CarouselSlide[] => {
    return [
        {
            id: 1,
            image: getCarouselImageUrl('img_carousel_1.png'),
            title: 'Bienvenue chez Eldaï',
            subtitle: 'Votre grossiste en produits casher de confiance, alliant tradition et modernité',
            ctaText: 'Découvrir nos produits',
            ctaLink: '/catalog'
        },
        {
            id: 2,
            image: getCarouselImageUrl('img_carousel_2.png'),
            title: 'Qualité Premium',
            subtitle: 'Une sélection rigoureuse des meilleurs produits casher pour votre commerce',
            ctaText: 'Voir le catalogue',
            ctaLink: '/catalog'
        },
        {
            id: 3,
            image: getCarouselImageUrl('img_carousel_3.png'),
            title: 'Livraison Express',
            subtitle: 'Commandez en ligne et recevez vos produits en 24-48h partout en France',
            ctaText: 'Commander maintenant',
            ctaLink: '/catalog'
        }
    ];
};
